import noneRuntime_36K5EaNERUNR0wZctEM_45bGIeUtaEa52larzLOzRu3ojrs from '/srv/projects/www.cultus-dresden.de/site/node_modules/.pnpm/@nuxt+image@2.1.0_@types+node@24.13.3_magic-string@1.1.0_magicast@0.5.4_rolldown@1.2.3__c2d5f1e2c0cb194c135ba2e7148c399a/node_modules/@nuxt/image/dist/runtime/providers/none'
import gsRuntime_36we0r7YYv1HCmLPciJOdK2GWU_xFikhMApOJSI8T3b9I from '/srv/projects/www.cultus-dresden.de/api/vendors/gsmaterials/imgProvider.ts'

export const imageOptions = {
  screens: {"sm":640,"md":768,"lg":1024,"xl":1280,"2xl":1536},
  presets: {},
  domains: [],
  alias: {},
  densities: [1,2],
  format: ["webp"],
  quality: undefined,
  /** @type {"gs"} */
  provider: "gs",
  providers: {
      ['none']: { setup: noneRuntime_36K5EaNERUNR0wZctEM_45bGIeUtaEa52larzLOzRu3ojrs, defaults: true },
  ['gs']: { setup: gsRuntime_36we0r7YYv1HCmLPciJOdK2GWU_xFikhMApOJSI8T3b9I, defaults: undefined }
  }
}
